var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm10 md10" },
        [
          _c(
            "FormFieldsContainer",
            { on: { resultadoBusqueda: _vm.filtroRequerimiento } },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.requerimiento.label,
                              items: _vm.requermientoslist,
                              "item-text": "asigrequerimiento",
                              "item-value": "asigrequerimiento",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.requerimiento.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.requerimiento,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.requerimiento.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.tecnico.label,
                              items: _vm.tecnicolist,
                              "item-text": "tecniconame",
                              "item-value": "tecnicoid",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.tecnico.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.tecnico, "value", $$v)
                              },
                              expression: "formFields.tecnico.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.localidad.label,
                              items: _vm.localidadlist,
                              "item-text": "locaname",
                              "item-value": "locaid",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.localidad.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.localidad, "value", $$v)
                              },
                              expression: "formFields.localidad.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm4: "", md4: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleBuscarClick } },
                              [
                                _c("v-icon", [_vm._v("search")]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { on: { click: _vm.clearFilters } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  small: "",
                                  color: "primary"
                                },
                                on: { click: _vm.btn_exportar }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "importExportBtnIcon" },
                                  [_vm._v("cloud_download")]
                                ),
                                _vm._v("  \n                "),
                                _c(
                                  "span",
                                  { staticClass: "importExportBtnTexto" },
                                  [_vm._v("Exportar"), _c("br"), _vm._v("CSV")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticStyle: { "margin-right": "5px" },
                        attrs: { label: "Buscar...", "append-icon": "search" },
                        on: { input: _vm.searchData },
                        model: {
                          value: _vm.filtrobusquedagrilla,
                          callback: function($$v) {
                            _vm.filtrobusquedagrilla = $$v
                          },
                          expression: "filtrobusquedagrilla"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleModal", {
            attrs: {
              reporte_Seleccionado: _vm.reporteSeleccionado,
              serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
              tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado,
              serieactivanroSeleccionado: _vm.serieactivanroSeleccionado
            },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }